import { render, staticRenderFns } from "./journal-modal___1.vue?vue&type=template&id=45fc5c52&scoped=true"
import script from "./journal-modal___1.vue?vue&type=script&lang=js"
export * from "./journal-modal___1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc5c52",
  null
  
)

export default component.exports